import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cabecalho: {
    display: 'flex',
    marginBottom: '40px',
    justifyContent: 'space-between',
  },
  itens: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '30px',
  },
  formularioTitulo: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    textTransform: 'uppercase',
  },
  avatar: {
    width: 88,
    height: 88,
    border: 'solid 1.8px #dfdfe6',
  },
  imagemReplaceFoto: {
    width: 88,
    height: 88,
    backgroundColor: '#30b0ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
    marginBottom: 30,
  },
  shareButton: {
    position: 'absolute',
    top: 30,
    right: 30,
    color: '#0061ff',
    cursor: 'pointer',
  },
}));

export default useStyles;
